import axios from "axios";

// ---------------------------
// Base URL Configuration
// ---------------------------
const BaseUrl =
  process.env.REACT_APP_API_URL_TYPE === "test"
    ? process.env.REACT_APP_API_URL_TEST
    : process.env.REACT_APP_API_URL_TYPE === "local"
    ? process.env.REACT_APP_API_URL_LOCAL
    : process.env.REACT_APP_API_URL_TYPE === "ngrok"
    ? process.env.REACT_APP_API_URL_NGROK
    : "";

const AuthBaseUrl =
  process.env.REACT_APP_API_URL_TYPE === "test"
    ? process.env.REACT_APP_API_URL_TEST_AUTH
    : process.env.REACT_APP_API_URL_TYPE === "local"
    ? process.env.REACT_APP_API_URL_LOCAL_AUTH
    : process.env.REACT_APP_API_URL_TYPE === "ngrok"
    ? process.env.REACT_APP_API_URL_NGROK_AUTH
    : "";

// ---------------------------
// JSON API Instance
// ---------------------------
const axiosInstance = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
  },
});

axiosInstance.interceptors.request.use(
  config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
    },
  }),
  null,
  { synchronous: true }
);

// ---------------------------
// Multipart/FormData Instance (Main API)
// ---------------------------
const axiosInstanceForm = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
  },
});

axiosInstanceForm.interceptors.request.use(
  config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
    },
  }),
  null,
  { synchronous: true }
);

// ---------------------------
// Auth API Instance (JSON)
// ---------------------------
const axiosInstanceAuth = axios.create({
  baseURL: AuthBaseUrl,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
  },
});

axiosInstanceAuth.interceptors.request.use(
  config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
    },
  }),
  null,
  { synchronous: true }
);

// ---------------------------
// Auth API Instance (FormData)
// ---------------------------
const axiosInstanceAuthForm = axios.create({
  baseURL: AuthBaseUrl,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
  },
});

axiosInstanceAuthForm.interceptors.request.use(
  config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
    },
  }),
  null,
  { synchronous: true }
);

// ---------------------------
// Export all instances
// ---------------------------
export { axiosInstance, axiosInstanceForm, axiosInstanceAuth, axiosInstanceAuthForm };
